// extracted by mini-css-extract-plugin
export var alternative = "StrapiTwoColumns-module--alternative--abc1f";
export var columnContent = "StrapiTwoColumns-module--columnContent--a8b4a";
export var cta = "StrapiTwoColumns-module--cta--f2b7e";
export var hasTextWeightBold = "StrapiTwoColumns-module--has-text-weight-bold--3da17";
export var isUppercase = "StrapiTwoColumns-module--is-uppercase--a98de";
export var root = "StrapiTwoColumns-module--root--1b833";
export var wrapper = "StrapiTwoColumns-module--wrapper--4da7a";